import React, { Component, Fragment } from "react";
import { Helmet } from "react-helmet";

import Button from "../../components/general/Button/Button";

class AdminLandingPage extends Component {
  render() {
    const buttonWrapperStyle = {
      width: "60%",
      margin: "0 auto",
      display: "flex",
      justifyContent: "space-between"
    };

    return (
      <Fragment>
        <Helmet>
          <title>Boxi Admin</title>
        </Helmet>
        <div style={buttonWrapperStyle}>
          <Button style={{ width: "200px" }} path="/dashboard/admin/advertise">
            Advertise
          </Button>
          <Button style={{ width: "200px" }} path="/dashboard/admin/drive">
            Drive
          </Button>
          <Button style={{ width: "200px" }} path="/dashboard/admin/team">
            Boxi Team
          </Button>
          <Button style={{ width: "200px" }} path="/dashboard/admin/production">
            Production
          </Button>
        </div>
      </Fragment>
    );
  }
}

export default AdminLandingPage;
